import { NumberInput, Stack } from '@mantine/core';
import { Text } from '@repo/foundations';
import dayjs from 'dayjs';
import { BillingInfoBanner } from '../BudgetSettings/components/BillingInfoBanner';
import { BUDGET_DEFAULTS, BUDGET_LIMITS } from './constants';
import { useEditBudgetSettingsModal } from './hooks';

interface EditBudgetSettingsModalControllerProps {
	onSuccess?: () => void;
}

export function EditBudgetSettingsModalController({
	onSuccess,
}: EditBudgetSettingsModalControllerProps) {
	const { budgetSettings, budgetError, handleBudgetChange } =
		useEditBudgetSettingsModal({ onSuccess });

	return (
		<Stack spacing="md">
			<Text size="sm">
				Set a Spend limit to control AI token spending. When the budget is
				reached, AI token usage will be disabled until{' '}
				{dayjs(budgetSettings?.reset_date).format('MMM D, YYYY')}.
			</Text>
			<Text size="sm" c="dimmed">
				Spend limit is currently{' '}
				{budgetSettings?.enabled ? 'enabled' : 'disabled'}
			</Text>
			<NumberInput
				label="Spend limit:"
				placeholder={`$${BUDGET_DEFAULTS.MONTHLY_BUDGET}`}
				value={budgetSettings?.monthly_budget || BUDGET_DEFAULTS.MONTHLY_BUDGET}
				onChange={handleBudgetChange}
				min={BUDGET_LIMITS.MIN}
				max={BUDGET_LIMITS.MAX}
				step={BUDGET_LIMITS.STEP}
				error={budgetError}
			/>
			<BillingInfoBanner />
		</Stack>
	);
}
